<div id="wait" *ngIf="isLoading == 1">
  <mat-spinner></mat-spinner>
</div>

<div class="row mt-3 bone-mass-row">
  <div class="col-auto">
    <p class="mtitle mb-0">Select Vital to view trends</p>
  </div>
</div>
<div class="row mt-1">
  <div class="col-md-12">
    <label class="radioOpt"><input class="square-radio" type="radio" name="vital" id="curWtId" checked
        (change)="onVitalSelect('curWt')"> Current Weight</label>
    <label class="radioOpt"><input class="square-radio" type="radio" name="vital" (change)="onVitalSelect('bodyFat')">
      Body Fat</label>
    <label class="radioOpt"><input class="square-radio" type="radio" name="vital" (change)="onVitalSelect('bmi')">
      BMI</label>
    <label class="radioOpt"><input class="square-radio" type="radio" name="vital" (change)="onVitalSelect('bmr')">
      BMR</label>
    <label class="radioOpt"><input class="square-radio" type="radio" name="vital" (change)="onVitalSelect('muscPert')">
      Muscle Mass</label>
    <label class="radioOpt"><input class="square-radio" type="radio" name="vital" (change)="onVitalSelect('subFat')">
      Subcutaneous Fat</label>
    <label class="radioOpt"><input class="square-radio" type="radio" name="vital" (change)="onVitalSelect('viscFat')">
      Visceral Fat</label>
    <!-- <label class="radioOpt"><input class="square-radio" type="radio" name="vital" (change)="onVitalSelect('protein')"> 
      Protein</label> -->
    <!-- <label class="radioOpt"><input class="square-radio" type="radio" name="vital" (change)="onVitalSelect('boneMass')"> Bone Mass</label><br/> -->
    <label class="radioOpt radio-break"><input class="square-radio" type="radio" name="vital"
        (change)="onVitalSelect('tarWt')"> Target Weight</label>
  </div>
</div>

<div style="width: 90%; position: relative; min-height: 300px;">
  <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" [callbackFunction]="chartCallback"
    [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngular"
    style="width: 100%; height: 100%; display: block;"></highcharts-chart>
  <div *ngIf="bmiData.length < 1"
    style="position: absolute; top: 50%; left: 0; width: 100%; text-align: center; transform: translateY(-50%); pointer-events: none;">
    <h6 style="color: gray;">No Record found for selected date range</h6>
  </div>
</div>

<div class="row mt-3 bone-mass-row">
  <div class="col-auto">
    <div class="card bone-mass-card mb-2">
      <div class="card-body">
        <h5 class="card-title mb-1">Bone Mass</h5>
        <p class="card-text display-6 mb-0">
          {{ boneMassValue !== null ? (boneMassValue | number:'1.2-2') + ' lbs' : 'No data' }}
        </p>
      </div>
    </div>
  </div>
</div>